export default __webpack_public_path__ + "static/media/information--minimum-speed-100--g1.7102a855.png";